import "core-js/modules/es.array.push.js";
import MockExamAnswerCard from "@/components/mockExam/MockExamAnswerCard";
import MockExamQuestionRenderPage from "@/components/mockExam/MockExamQuestionRenderPage";
import api from "@/api";
import subjects from "@/utils/subjects";
import WatermarkerView from "@/components/WatermarkerView";
import DigitSymbolReactionSession from "@/components/subject/DigitSymbolReaction/DigitSymbolReactionSession.vue";
export default {
  name: "ExamTrainView",
  components: {
    MockExamQuestionRenderPage,
    MockExamAnswerCard,
    WatermarkerView,
    DigitSymbolReactionSession
  },
  data() {
    return {
      mockExamLeftTime: '-',
      subjects,
      leftSeconds: 0,
      leftTimeTask: null,
      activeName: 'first',
      examDetail: {},
      paperDetail: {},
      current: 0,
      paperType: this.$route.params.paperType,
      sessionId: this.$route.params.sessionId,
      examPlanId: this.$route.params.examPlanId,
      subject: '',
      unitOrder: 1,
      No: '',
      session: null,
      examing: false,
      tableData1: [{
        unit1: '15分钟',
        unit2: '20分钟',
        unit3: '10分钟',
        answer: '45分钟',
        all: '60分钟'
      }],
      tableData2: [{
        unit1: '5分钟',
        unit2: '5分钟',
        unit3: '5分钟',
        answer: '15分钟',
        all: '30分钟'
      }],
      fromPath: '',
      endShow: false,
      loading: false,
      examEndTime: '',
      units: [],
      buttonCountDown: 0
    };
  },
  computed: {
    subjectInfo() {
      return this.subjects.infoMap[this.subject];
    }
  },
  methods: {
    startCountdown() {
      if (this.fromPath === '/') {
        // 刷新页面
        this.buttonCountDown = 0; // 设置倒计时为59秒
      } else {
        this.buttonCountDown = 20; // 设置倒计时为59秒
      }
      const timer = setInterval(() => {
        if (this.buttonCountDown > 0) {
          this.buttonCountDown--;
        } else {
          clearInterval(timer);
        }
      }, 1000);
    },
    startUnitDesc() {
      this.loading = true;
      this.startCountdown();
    },
    async goToUnit() {
      if (this.activeName === 'first' && this.examing === false) {
        this.activeName = 'second';
      } else {
        this.startUnitDesc();
        await this.userStartMock();
      }
    },
    async goToExam() {
      await this.getCurrentQuestion();
      this.initTime();
      this.loading = false;
      this.examing = true;
    },
    ansTypeMap() {
      return subjects.ansTypeMap[this.subject];
    },
    ansModeMap() {
      return subjects.ansModeMap[this.subject];
    },
    async getExamDetail() {
      this.examDetail = await api.getmockExamDetail({
        examPlanId: this.examPlanId
      });
      this.No = this.examDetail.assessmentId;
      if (this.paperType === 'RETAKE') {
        this.paperDetail = this.examDetail.retakeExam;
        this.units = this.examDetail.retakeExam.units;
      } else {
        this.paperDetail = this.examDetail.initialExam;
        this.units = this.examDetail.initialExam.units;
      }
      switch (this.paperDetail.examStatus) {
        case 'TESTING':
        case 'INCOMPLETE':
        case 'SUBMITTED':
          {
            this.startUnitDesc();
            await this.userStartMock();
            break;
          }
        case 'COMPLETED':
          {
            this.endShow = true;
          }
      }
      // INITIAL RETAKE
    },
    async userStartMock() {
      const res = await api.userStartMock({
        examPlanId: this.examPlanId,
        paperType: this.paperType
      });
      console.log(res, '----userStartMock-----');
      this.sessionId = res.sessionId;
      this.unitOrder = res.currentUnit;
      this.subject = res.currentUnitSession.subject;
    },
    async getCurrentQuestion() {
      if (!this.sessionId) return;
      await api.getCurrentQuestion({
        sessionId: this.sessionId
      }).then(ret => {
        this.examEndTime = ret.examEndTime;
        console.log(ret, 'getCurrentQuestion==========');
        this.current = ret.questionData.current;
        this.session = {
          ...ret.questionData,
          unitOrder: ret.unitOrder,
          sessionId: ret.sessionId
        };
        this.subject = this.session.subject;
        this.unitOrder = ret.unitOrder;
      }).catch(e => {
        this.endShow = true;
        console.log(e, '--e---');
        // if(!this.endShow) {
        //   this.nextUnit()
        // }
        // this.$router.replace('/')
      });
    },
    async nextUnit() {
      if (this.unitOrder < 3) {
        this.unitOrder = this.unitOrder + 1;
        this.subject = this.units[this.unitOrder - 1].subject;
        console.log(this.unitOrder, "this.unitOrder===========");
        console.log(this.units, "this.units========");
        // await this.getCurrentQuestion()
        this.startUnitDesc();
        this.examing = false;
        // this.getCurrentQuestion().then(() => this.loading = false)
      } else {
        this.endShow = true;
      }
    },
    // onTimeUp() {
    //   this.$refs.questionRender.onTimeUp();
    // },
    goToExamList() {
      this.$router.push('/mock/exam');
    },
    secondsToMMSS(seconds) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      const formattedMinutes = String(minutes).padStart(2, '0');
      const formattedSeconds = String(remainingSeconds).padStart(2, '0');
      return `${formattedMinutes}:${formattedSeconds}`;
    },
    calcLeftTime() {
      // if (this.session?.state != 'TESTING') {
      //   //不在考试态，结束
      //   this.stopCalcLeftTime(false)
      //   return
      // }
      this.leftSeconds = Math.max(0, (this.examEndTime - new Date().getTime()) / 1000).toFixed(0);
      this.mockExamLeftTime = this.secondsToMMSS(this.leftSeconds);
      if (this.leftSeconds <= 0) {
        this.stopCalcLeftTime(false);
      }
    },
    stopCalcLeftTime(_init_) {
      console.log(this.leftTimeTask, ' stopCalcLeftTime======');
      if (this.leftTimeTask) {
        clearInterval(this.leftTimeTask);
      }
      if (!_init_) {
        // this.$emit('timeup')
        this.nextUnit();
      }
    },
    async initTime() {
      this.leftSeconds = 0;
      this.leftTimeTask = null;
      this.stopCalcLeftTime(true);
      this.calcLeftTime();
      this.leftTimeTask = setInterval(() => {
        this.calcLeftTime();
      }, 1000);
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fromPath = from.fullPath;
    });
  },
  beforeMount() {
    this.getExamDetail();
  },
  unmounted() {
    console.log('清理考试计时器');
    this.stopCalcLeftTime(true);
  }
};